import React from "react";
import { thisBaseURL } from "../../utils/helper.js";

function PopulationField({defaultCountry, heading, year, value, notes, sourceRef}){
	return(
		<div>
			<h3>
			{heading}
				{year ? 
				<small>&nbsp;({year})</small> 
				:""}
				{sourceRef && sourceRef > 0 ?
				<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+sourceRef}>{sourceRef}</a></small>:
				""
				}
			</h3>
			<p>{value}</p>
			{notes ? 
				<p className="notes-info" style={{marginTop: "auto"}}>
				<em>{notes}</em>
				</p>
			: ""}
		</div>
	)
}

export default PopulationField;